module.exports = __webpack_public_path__ + "icon-memo.svg?d36ef9556d621a9c2597aaf514327bbb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-memo.svg
// module id = 640
// module chunks = 0